import React from "react";

const PlatformUsageIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <rect
        x="1"
        y="1"
        width="12"
        height="12"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.2"
        fill="none"
      ></rect>
      <path
        d="M4 7h6M4 4.5h4M4 9.5h3"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
      ></path>
    </svg>
  );
};

export default PlatformUsageIcon;
